import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import messages from './employeeProfileMessages';

const AddEmployeeProfileModal = ({ show, onClose, onSave }) => {
  const intl = useIntl();
  const [name, setName] = useState('');

  const handleClose = () => {
    setName('');
    onClose();
  };

  const handleSave = () => onSave(name);

  return (
    <OkCancelModal
      show={show}
      title={intl.formatMessage(messages.NewEmployeeProfile)}
      onClose={handleClose}
      onSave={handleSave}
      disabled={!name.trim()}
      okLabel={intl.formatMessage(messages.Add)}
      disableFullScreen
    >
      <div className="form-horizontal form-labels-left" role="form">
        <div className="form-group">
          <label htmlFor="employeeProfileName" className="col-sm-4 control-label">
            <FormattedMessage {...messages.Name} />
          </label>
          <div className="col-sm-8">
            <input
              className="form-control"
              id="employeeProfileName"
              type="text"
              required
              value={name}
              onChange={e => setName(e.target.value)}
              autoFocus
            />
          </div>
        </div>
      </div>
    </OkCancelModal>
  );
};

export default AddEmployeeProfileModal;
